import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getContracts = actionFactory(types.GET_CONTRACTS);
export const createContract = actionFactory(types.CREATE_CONTRACT);
export const deleteContract = actionFactory(types.DELETE_CONTRACT);
export const updateContract = actionFactory(types.UPDATE_CONTRACT);
